var React = require('react');

function ArrowDownInline (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_250_16141","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"36","height":"36","key":0},React.createElement("rect",{"width":"36","height":"36","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_250_16141)","key":1},React.createElement("path",{"d":"M18.0003 22.5575L9.51953 14.0768L11.1003 12.4961L18.0003 19.3961L24.9003 12.4961L26.481 14.0768L18.0003 22.5575Z","fill":"#747474"}))]);
}

ArrowDownInline.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = ArrowDownInline;

ArrowDownInline.default = ArrowDownInline;
